const CHANNEL_NAME = "enkey-rpc-mutations";
const STORAGE_KEY = "enkey.rpc.mutation";

export function publishRpcMutation(): void {
  if (typeof window === "undefined") return;
  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ type: "mutation", at: Date.now() });
    channel.close();
    return;
  }
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      `${Date.now()}:${crypto.randomUUID()}`,
    );
  } catch {
    // Current-tab cache invalidation still works when browser storage is denied.
  }
}

export function subscribeRpcMutations(callback: () => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.addEventListener("message", callback);
    return () => channel.close();
  }
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY) callback();
  };
  window.addEventListener("storage", onStorage);
  return () => window.removeEventListener("storage", onStorage);
}
